import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import {
  DATA_SOURCE_DOMAIN_TYPE_OPTIONS,
  DataSourceConfigsEnums,
  DATA_SOURCE_IDENTIFIER_OPTIONS,
  DATA_SOURCE_ENDPOINT_OPTIONS,
} from 'lib/enums/DataSourceEnum';
import APIIntegrationSelector from 'components/manage_vendors/vendor_details/APIIntegration/APIIntegrationSelector';
import Select from 'react-select';

const DataSourceConfigs = ({ configs, setConfigs, globalVendorId }) => {
  // domain type
  const currentValue = configs[DataSourceConfigsEnums.DOMAIN_TYPE];
  const selectedOption =
    DATA_SOURCE_DOMAIN_TYPE_OPTIONS.find(opt => opt.value === currentValue) || null;

  // identifier
  const currentIdentifierValue = configs[DataSourceConfigsEnums.IDENTIFIER];
  const selectedIdentifierOption =
    DATA_SOURCE_IDENTIFIER_OPTIONS.find(opt => opt.value === currentIdentifierValue) || null;

  // endpoint
  const currentEndpointValue = configs[DataSourceConfigsEnums.ENDPOINT];
  const selectedEndpointOption =
    DATA_SOURCE_ENDPOINT_OPTIONS.find(opt => opt.value === currentEndpointValue) || null;

  return (
    <div>
      <APIIntegrationSelector
        globalVendorId={globalVendorId}
        selectedIntegrationId={configs[DataSourceConfigsEnums.API_INTEGRATION_ID]}
        onIntegrationChange={integrationId =>
          setConfigs({
            ...configs,
            [DataSourceConfigsEnums.API_INTEGRATION_ID]: integrationId,
          })
        }
        label="API Integration (Select the API credentials to use for this data source)"
      />
      <Form.Group>
        <Form.Label>Domain Type (What type of Syndigo API are you using?)</Form.Label>
        <Select
          value={selectedOption}
          options={DATA_SOURCE_DOMAIN_TYPE_OPTIONS}
          onChange={e =>
            setConfigs({ ...configs, [DataSourceConfigsEnums.DOMAIN_TYPE]: e ? e.value : null })
          }
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Identifier (What is the identifier for the Syndigo API?)</Form.Label>
        <Select
          value={selectedIdentifierOption}
          options={DATA_SOURCE_IDENTIFIER_OPTIONS}
          onChange={e =>
            setConfigs({ ...configs, [DataSourceConfigsEnums.IDENTIFIER]: e ? e.value : null })
          }
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Endpoint (What is the endpoint for the Syndigo API?)</Form.Label>
        <Select
          value={selectedEndpointOption}
          options={DATA_SOURCE_ENDPOINT_OPTIONS}
          onChange={e =>
            setConfigs({ ...configs, [DataSourceConfigsEnums.ENDPOINT]: e ? e.value : null })
          }
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>
          Vocabulary ID (If not provided, the default vocabulary will be used)
        </Form.Label>
        <Form.Control
          type="text"
          value={configs[DataSourceConfigsEnums.VOCABULARY_ID]}
          onChange={e =>
            setConfigs({ ...configs, [DataSourceConfigsEnums.VOCABULARY_ID]: e.target.value })
          }
        />
      </Form.Group>
    </div>
  );
};

DataSourceConfigs.propTypes = {
  configs: PropTypes.object.isRequired,
  setConfigs: PropTypes.func.isRequired,
  globalVendorId: PropTypes.number,
};

export default DataSourceConfigs;
